//
import Model from '@/models/Model'

/**
 * @class
 */
export default class PchDetailPurchaseOrder extends Model {
    //
    static headers = [
        {
            text: 'código de proveedor',
            value: 'provider_product_code',
            input: {
                reverse: true,
                min: 1,
                type: 'text-field',
            },
            width: '10%',
        },
        {
            text: 'código interno',
            value: 'wh_product_internal_code',
            width: '10%',
        },
        {
            text: 'nombre',
            value: 'wh_product_name',
        },
        {
            text: 'precio neto',
            value: 'net_price',
            input: {
                type: 'currency-field',
                reverse: true,
            },
            align: 'right',
            format: 'currency',
            width: '10%',
        },
        {
            text: 'cantidad',
            value: 'quantity',
            input: {
                type: 'float-field',
                reverse: true,
            },
            align: 'right',
            format: 'number',
            width: '10%',
        },
    ]

    /**
     *
     */
    get wh_product_alias_name() {
        return this.wh_product ? this.wh_product.alias_name : '-'
    }

    /**
     *
     */
    get wh_product_internal_code() {
        return this.wh_product ? this.wh_product.internal_code : '-'
    }

    /**
     *
     */
    get wh_product_name() {
        return this.wh_product ? this.wh_product.name : '-'
    }

    /**
     *
     */
    get wh_product_service_name() {
        return this.wh_product_service ? this.wh_product_service.name : '-'
    }

    /**
     * @description
     */
    reset() {
        //
        this.provider_product_code = this.last_provider_code || ''
        this.net_price = 1
        this.quantity = 1
        this.wh_product = this
        this.wh_product_id = this.id
        //
        return this
    }

    /**
     * @description
     */
    resource() {
        return 'pch_detail_purchase_order'
    }
}
